CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
CustomFieldItem = require 'models/custom-field-item'

module.exports = class CustomFieldItemList extends CollectionWithHelpers
  model: CustomFieldItem



// WEBPACK FOOTER //
// ./app/scripts/models/collections/custom-field-item-list.coffee